// extracted by mini-css-extract-plugin
export var container = "notifications-module--container--96yy5";
export var header = "notifications-module--header--JZg87";
export var list = "notifications-module--list--LTTPo";
export var listBox = "notifications-module--list-box--7QsvJ";
export var listItem = "notifications-module--list-item--HYnxq";
export var newAvailableButton = "notifications-module--new-available-button--NXL1X";
export var newAvailableMessage = "notifications-module--new-available-message--xOXWQ";